<div class="no-event vh-100 d-flex justify-content-center align-items-center">
    <p class="p-0 m-0" style="font-weight: bolder; font-size: 5rem;">Event Not Found</p>
</div>